import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  class: "menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold py-4 fs-6 w-275px",
  "data-kt-menu": "true"
}
const _hoisted_2 = { class: "menu-item px-3" }
const _hoisted_3 = { class: "menu-content d-flex align-items-center px-3" }
const _hoisted_4 = { class: "symbol symbol-50px me-5" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 1,
  alt: "Logo",
  src: "/media/avatars/blank.png"
}
const _hoisted_7 = { class: "d-flex flex-column" }
const _hoisted_8 = { class: "fw-bolder d-flex align-items-center fs-5" }
const _hoisted_9 = {
  href: "javascript:void(0);",
  class: "fw-bold text-muted text-hover-primary fs-7"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "separator my-2" }, null, -1)
const _hoisted_11 = { class: "menu-item px-5" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.user.avatar)
            ? (_openBlock(), _createElementBlock("img", {
                key: 0,
                alt: "Logo",
                src: _ctx.user.avatar
              }, null, 8, _hoisted_5))
            : (_openBlock(), _createElementBlock("img", _hoisted_6))
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.user.firstName), 1),
          _createElementVNode("a", _hoisted_9, _toDisplayString(_ctx.user.name), 1)
        ])
      ])
    ]),
    _hoisted_10,
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.signOut())),
        class: "menu-link px-5"
      }, " Sign Out ")
    ])
  ]))
}